module.exports = __webpack_public_path__ + "media/category_icons/Gastroenterology-37222835.svg";